import { ActionContext } from 'vuex';
import { GeneralHelper } from '../../helper/general';

const loadingStates: any = {};
const helper = new GeneralHelper();

interface ILoadState {
	status: boolean;
	url: string;
}

export default {
	state: {
		app: {
		},
		configuration_loaded: false,
		api_loading: false,
		api_loading_wait: 2000,
		configuration: {
			licenceModel: 'Record Creation',
			limitLicensedUsers: null,
			maxApplications: 15,
			maxEnvironments: 10,
			productionEnvironmentId: 3,
			mainDomain: '',
			allowedVersions: [],
			releasedVersions: [] as number[],
			customDomains: [],
			licensedAttendedBots: 0,
			licensedUnattendedBots: 0,
			licensedDeveloperBots: 0,
			latestRpaExecutableVersion: '',
			versionsData: [],
			maxBackups: 0,
			isRpaActive: true,
			isCreateActive: true,
			isAiActive: true,
			isMultipleInstances: false,
			isMultiTenantController: false,
			resourceOptions: [],
			isViewNetcallUsers: false,
			allowedBackup: true,
			allowedUpgrade: true,
			maxCustomDomains: 0,
			maxAiModels: 0,
			isConverseActive: true,
			isConverseAccountCreated: true,
			isMultiTenant: false,
			totalAttendedBots: 0,
			totalUnattendedBots: 0,
			totalDeveloperBots: 0,
			isMultiInstances: false,
			serverWarnings: [],
			rpaReleasedVersions: [],
			rpaVersionsData: [],
			createVersionsData: [],
			isSparkActive: true,
			isSparkAccountCreated: true,
			isIdpActive: true,
			isAiUnitActive: false,
			reservedLengthForAppSubdomain: 0,
			currentVersion: '',
			aiEnv: '',
			idpEnv: '',
			sparkEnv: '',
			converseEnv: '',
			pulseId: '',
			dayOfWeek: '',
			weeks: 0,
			nextPatchingDates: [] as string[],
			displaySettings: {
				hideExploreColumnOnDashboard: false,
			},
		},
	},
	mutations: {
		SET_CONFIGURATION: (state: any, configuration: any) => {
			state.configuration = configuration;
			state.configuration_loaded = true;
		},

		SET_LOADING_STATE: (state: any, status: boolean) => {
			state.api_loading = status;
		},
		SET_SPARK_ACCOUNT_CREATED: (state: any, value: boolean) => {
			state.configuration.isSparkAccountCreated = value;
		},
		SET_CONVERSE_XC_ACCOUNT_CREATED: (state: any, value: boolean) => {
			state.configuration.isConverseAccountCreated = value;
		},
	},
	actions: {
		setConfiguration: (context: ActionContext<any, any>, configuration: any) => {
			const pConfiguration = {
				licenceModel: configuration.licenceModel,
				limitLicensedUsers: parseInt(configuration.limitLicensedUsers),
				maxApplications: parseInt(configuration.maxApplications),
				maxEnvironments: parseInt(configuration.maxEnvironments),
				productionEnvironmentId: parseInt(configuration.productionEnvironmentId),
				mainDomain: configuration.mainDomain,
				allowedVersions: configuration.allowedVersions,
				releasedVersions: configuration.releasedVersions,
				customDomains: configuration.customDomains,
				licensedAttendedBots: parseInt(configuration.licensedAttendedBots),
				licensedUnattendedBots: parseInt(configuration.licensedUnattendedBots),
				licensedDeveloperBots: parseInt(configuration.licensedDeveloperBots),
				maxBackups: parseInt(configuration.maxBackups),
				versionsData: configuration.versionsData,
				latestRpaExecutableVersion: configuration.latestRpaExecutableVersion,
				isRpaActive: configuration.isRpaActive,
				isCreateActive: configuration.isCreateActive,
				isAiActive: configuration.isAiActive,
				isMultipleInstances: configuration.isMultipleInstances,
				isMultiTenantController: configuration.isMultiTenantController,
				resourceOptions: configuration.resourceOptions,
				isViewNetcallUsers: configuration.isViewNetcallUsers,
				allowedBackup: configuration.allowedBackup,
				allowedUpgrade: configuration.allowedUpgrade,
				maxCustomDomains: parseInt(configuration.maxCustomDomains),
				maxAiModels: parseInt(configuration.maxAiModels),
				isConverseActive: configuration.isConverseActive,
				isConverseAccountCreated: configuration.isConverseAccountCreated,
				isMultiTenant: configuration.isMultiTenant,
				totalAttendedBots: configuration.totalAttendedBots,
				totalUnattendedBots: configuration.totalUnattendedBots,
				totalDeveloperBots: configuration.totalDeveloperBots,
				isMultiInstances: configuration.isMultiInstances,
				serverWarnings: configuration.serverWarnings,
				rpaReleasedVersions: configuration.rpaReleasedVersions,
				rpaVersionsData: configuration.rpaVersionsData,
				createVersionsData: configuration.createVersionsData,
				isSparkActive: configuration.isSparkActive,
				isSparkAccountCreated: configuration.isSparkAccountCreated,
				isIdpActive: configuration.isIdpActive,
				isAiUnitActive: configuration.isAiUnitActive,
				reservedLengthForAppSubdomain: configuration.reservedLengthForAppSubdomain,
				currentVersion: configuration.currentVersion,
				aiEnv: configuration.aiEnv,
				idpEnv: configuration.idpEnv,
				sparkEnv: configuration.sparkEnv,
				converseEnv: configuration.converseEnv,
				pulseId: configuration.pulseId,
				dayOfWeek: configuration.dayOfWeek,
				weeks: Number.parseInt(configuration.weeks),
				nextPatchingDates: configuration.nextPatchingDates,
				displaySettings: configuration.displaySettings,
			};
			context.commit('SET_CONFIGURATION', pConfiguration);
		},

		setLoading: (context: ActionContext<any, any>, load: ILoadState) => {
			const uniqueUrl = helper.cleanString(load.url);
			if (load.status === true) {
				loadingStates[uniqueUrl] = setTimeout(() => {
					context.commit('SET_LOADING_STATE', load.status);
					clearTimeout(loadingStates[uniqueUrl]);
					delete loadingStates[uniqueUrl];
				}, context.state.api_loading_wait);
			} else {
				clearTimeout(loadingStates[uniqueUrl]);
				delete loadingStates[uniqueUrl];
				if (Object.keys(loadingStates).length === 0) {
					context.commit('SET_LOADING_STATE', load.status);
				}
			}
		},
	},
};
